import { render } from "./CharactersPage.vue?vue&type=template&id=bb6928f2"
import script from "./CharactersPage.vue?vue&type=script&lang=ts"
export * from "./CharactersPage.vue?vue&type=script&lang=ts"

import "./CharactersPage.vue?vue&type=style&index=0&id=bb6928f2&lang=scss"
script.render = render

export default script